import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import FormatTooling from '../../../tooling/formatTooling';
import LocaleTooling from '../../../tooling/localeTooling';
import Constants from '../../../definitions/constants';

import GlassPopup from '../common/interface/glassPopup';
import ToggleSection from '../common/interface/toggleSection';
import TextBox from '../common/inputs/textBox';
import CheckBox from '../common/inputs/checkBox';
import Select from '../common/inputs/select';
import FreeTextList from '../common/inputs/freeTextList';
import Label from '../common/inputs/label';
import ErrorFeedback from '../common/feedback/errorFeedback';
import EndpointParamsSelector from './endpointParamsSelector';
import EndpointHeadersSelector from './endpointHeadersSelector';
import ConnectorFieldsMappingList from './connectorFieldsMappingList';
import ConnectorFieldsMappingFilterSelector from './connectorFieldsMappingFilterSelector';
import FormSection from '../common/interface/formSection';
import HoverTooltip from '../common/interface/hoverTooltip';



const FormPopup = props => {
  const {
    handleShowPopup,
    handleOnChangeForm,
    handleButton,
    loadingButton,
    fullLoading,
    statusButton,
    formData,
    errors,
    entityNameSingular,
    popupState,
    calculationUnitTypeFieldsOptionsList, // array: Array of strings with the fields for when the connector type is calculation units
    usersList, // array: Array with the users list for when the connector type is calculation units
    metricValueTypeMetricGroupOptionsList, // array: Array with objects of format {id, name, mapping_fields} with the options for the metric group select for when the connector type is metric values
    metricValueTypeFieldsOptionsList, // array: Array of metricGroups data, with format {id, name, headers, use_pivot_column} for the metric values connector type
    loginTypeVariablesOptionsList, // array: Array of standard select's format with the options for the connector_login_token_variable for when the connector type is login
    handleSetDefaultConnectorMappingFields, // function: Function to set the default fields for the endpoint_connector_mapping
    handleGetExternalFieldOptionsList, // function: Function to get the external fields for the endpoint_connector_mapping.mapping_external_field
    externalFieldOptionsList, // array: Array of strings with the suggested external fields for the endpoint_connector_mapping.mapping_external_field
    dimensionsList
  } = props;
  let endpointConnectorType = JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.endpoint_connector_type");
  let pathFieldsEnabled = (endpointConnectorType != Constants.selectKeys.endpoint.endpoint_connector_type.output_export_calculation_units_reports_endpoint_type &&
    endpointConnectorType != Constants.selectKeys.endpoint.endpoint_connector_type.output_export_calculation_units_calculations_endpoint_type) ||
    JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.output_connectors_has_return_data");
  let outputsMappingEnabled = (endpointConnectorType == Constants.selectKeys.endpoint.endpoint_connector_type.output_export_calculation_units_reports_endpoint_type ||
      endpointConnectorType == Constants.selectKeys.endpoint.endpoint_connector_type.output_export_calculation_units_calculations_endpoint_type) &&
      JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.output_connectors_has_return_data");
  let showMapping = endpointConnectorType == Constants.selectKeys.endpoint.endpoint_connector_type.calculation_units_endpoint_type ||
    endpointConnectorType == Constants.selectKeys.endpoint.endpoint_connector_type.metric_values_endpoint_type ||
    outputsMappingEnabled;
  let outputConnectorType = endpointConnectorType == Constants.selectKeys.endpoint.endpoint_connector_type.output_export_calculation_units_reports_endpoint_type ||
    endpointConnectorType == Constants.selectKeys.endpoint.endpoint_connector_type.output_export_calculation_units_calculations_endpoint_type;

  let metricGroupSelectedId = JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.connector_metric_values_metric_group_id")
  let metricGroupItem = (metricGroupSelectedId && metricValueTypeFieldsOptionsList) ? metricValueTypeFieldsOptionsList.find(item => item.id == metricGroupSelectedId) : null;
  let metricValueTypeFieldsOptionsHeaders = metricGroupItem ? metricGroupItem.headers : null
  let metricGroupSelectedAndValid = metricGroupSelectedId && metricValueTypeFieldsOptionsHeaders;
  let metricGroupUsePivotColumn = metricGroupItem ? metricGroupItem.use_pivot_column : false;

  // logic variables to determine if period or calculation unit mapping should be excluded
  let activeMetricMapping = ((outputsMappingEnabled || endpointConnectorType == Constants.selectKeys.endpoint.endpoint_connector_type.metric_values_endpoint_type) &&
    metricGroupSelectedAndValid);
  let excludeCalculationUnitMapping = (activeMetricMapping && (outputsMappingEnabled || JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.connector_metric_values_iterate_calculation_units")) && 
      JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.connector_metric_values_ignore_calculation_unit") || 
    ((JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.endpoint_connector_type") == Constants.selectKeys.endpoint.endpoint_connector_type.calculation_unit_group_or_model_associations_endpoint_type) && 
      JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.connector_metric_values_iterate_calculation_units") && JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.connector_metric_values_ignore_calculation_unit")));
  let excludePeriodMapping = activeMetricMapping && JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.connector_metric_values_ignore_period");

  let calculationUnitModelAssociationDefaultFields = [
    intl.formatMessage({id: "endpointsConnectorsAdmin.calculationUnitAssociationsDefaultFields.calculation_unit_code"}),
    intl.formatMessage({id: "endpointsConnectorsAdmin.calculationUnitAssociationsDefaultFields.model_name"}),
    intl.formatMessage({id: "endpointsConnectorsAdmin.calculationUnitAssociationsDefaultFields.association_id"}),
  ]
  let calculationUnitGroupAssociationDefaultFields = [
    intl.formatMessage({id: "endpointsConnectorsAdmin.calculationUnitAssociationsDefaultFields.calculation_unit_code"}),
    intl.formatMessage({id: "endpointsConnectorsAdmin.calculationUnitAssociationsDefaultFields.group_name"}),
  ]
  return (
    <GlassPopup
      className="form_popup endpoints_connectors_form_popup"
      title={(<FormattedMessage 
         id={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.id") ? "common.entity.editEntity" : "common.entity.createEntity"}
         values={{entityNameSingular: entityNameSingular}}
       />)}
      buttonText={(<FormattedMessage 
         id={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.id") ? "common.entity.editEntity" : "common.entity.createEntity"}
         values={{entityNameSingular: entityNameSingular}}
       />)}
      type={Constants.interface.popup.types.LATERAL}
      {...props}
    >
      <ErrorFeedback
        status={statusButton}
        fieldErrors={errors}
        localesFieldsPath="endpointsConnectorsAdmin.fields"
      />
      <TextBox 
        styleType={Constants.interface.inputs.styleType.OUTLINED}
        type={Constants.interface.inputs.type.TEXT}
        id="name"
        data-path="endpoint_connector.name"
        value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.name")}
        onChange={handleOnChangeForm}
        labelLocale={<FormattedMessage id="endpointsConnectorsAdmin.fields.name"/>}
        className={("name" in errors) ? "has_error" : null}
      />
      <TextBox 
        styleType={Constants.interface.inputs.styleType.OUTLINED}
        type={Constants.interface.inputs.type.TEXT}
        id="endpoint_url"
        data-path="endpoint_connector.endpoint_url"
        value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.endpoint_url")}
        onChange={handleOnChangeForm}
        labelLocale={<FormattedMessage id="endpointsConnectorsAdmin.fields.endpoint_url"/>}
        className={("endpoint_url" in errors) ? "has_error" : null}
      />
      <Select 
        id="endpoint_method"
        data-path="endpoint_connector.endpoint_method"
        value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.endpoint_method")}
        onChange={handleOnChangeForm}
        labelLocale={<FormattedMessage id="endpointsConnectorsAdmin.fields.endpoint_method"/>}        
        options={InterfaceTooling.getSelectArray("selectKeys.endpoint.endpoint_method","endpointsConnectorsAdmin.fields.selectValues.endpoint_method", true)}
      />
      <EndpointHeadersSelector
        id="endpoint_headers"
        data-path="endpoint_connector.endpoint_headers"
        onChange={handleOnChangeForm}
        values={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.endpoint_headers") ? JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.endpoint_headers") : []}
        className={"endpoint_headers_editor" + (("endpoint_headers" in errors) ? " has_error" : "")}
      />
      <EndpointParamsSelector
        id="endpoint_parameters"
        data-path="endpoint_connector.endpoint_parameters"
        onChange={handleOnChangeForm}
        values={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.endpoint_parameters") ? JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.endpoint_parameters") : []}
        className={"endpoint_params_editor" + (("endpoint_parameters" in errors) ? " has_error" : "")}
      />
      <FormSection labelLocale={intl.formatMessage({id: "endpointsConnectorsAdmin.formSections.dataRoute"})} 
      // toolTipContent="Tooltip de prueba"
      />
      <TextBox 
        styleType={Constants.interface.inputs.styleType.OUTLINED}
        type={Constants.interface.inputs.type.TEXT}
        id="endpoint_return_data_path"
        data-path="endpoint_connector.endpoint_return_data_path"
        value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.endpoint_return_data_path")}
        onChange={handleOnChangeForm}
        labelLocale={<FormattedMessage id="endpointsConnectorsAdmin.fields.endpoint_return_data_path"/>}
        className={("endpoint_return_data_path" in errors) ? "has_error" : null}
        disabled={!pathFieldsEnabled}
      />
      <TextBox 
        styleType={Constants.interface.inputs.styleType.OUTLINED}
        type={Constants.interface.inputs.type.TEXT}
        id="endpoint_return_inner_data_path"
        data-path="endpoint_connector.endpoint_return_inner_data_path"
        value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.endpoint_return_inner_data_path")}
        onChange={handleOnChangeForm}
        labelLocale={<FormattedMessage id="endpointsConnectorsAdmin.fields.endpoint_return_inner_data_path"/>}
        className={("endpoint_return_inner_data_path" in errors) ? "endpoint_return_inner_data_path has_error" : "endpoint_return_inner_data_path"}
        disabled={!pathFieldsEnabled}
      />
      <FormSection labelLocale={intl.formatMessage({id: "endpointsConnectorsAdmin.formSections.scheduleExecution"})}/>
      <Select 
        id="connector_schedule"
        data-path="endpoint_connector.connector_schedule"
        value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.connector_schedule")}
        onChange={handleOnChangeForm}
        labelLocale={<FormattedMessage id="endpointsConnectorsAdmin.fields.connector_schedule"/>}        
        options={InterfaceTooling.getSelectArray("selectKeys.endpoint.connector_schedule","endpointsConnectorsAdmin.fields.selectValues.connector_schedule", true)}
      />
      <label className="form_info">
        <FormattedMessage 
          id={"endpointsConnectorsAdmin.scheduleHelp"}
        />
      </label>
      {(JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.connector_schedule") == Constants.selectKeys.endpoint.connector_schedule.period_date) && (
        <React.Fragment>
          <div className="row_fields">
            <Select 
              id="connector_schedule_period_date"
              data-path="endpoint_connector.connector_schedule_period_date"
              value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.connector_schedule_period_date")}
              onChange={handleOnChangeForm}
              labelLocale={<FormattedMessage id="endpointsConnectorsAdmin.fields.connector_schedule_period_date"/>}        
              options={InterfaceTooling.getSelectArray("selectKeys.endpoint.connector_schedule_period_date","endpointsConnectorsAdmin.fields.selectValues.connector_schedule_period_date", true)}
            />
          </div>
          <div className="row_fields">
            <TextBox 
              styleType={Constants.interface.inputs.styleType.OUTLINED}
              type={Constants.interface.inputs.type.TEXT}
              id="connector_schedule_date_formula"
              data-path="endpoint_connector.connector_schedule_date_formula"
              value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.connector_schedule_date_formula")}
              onChange={handleOnChangeForm}
              dataType={Constants.selectKeys.metric.dataType.NUMBER}
              labelLocale={<FormattedMessage id="endpointsConnectorsAdmin.fields.connector_schedule_date_formula"/>}
              className={("connector_schedule_date_formula" in errors) ? "has_error" : null}
            />
            <TextBox 
              styleType={Constants.interface.inputs.styleType.OUTLINED}
              type={Constants.interface.inputs.type.TEXT}
              id="connector_schedule_time"
              data-path="endpoint_connector.connector_schedule_time"
              value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.connector_schedule_time")}
              onChange={handleOnChangeForm}
              dataType={Constants.selectKeys.metric.dataType.TIME}
              labelLocale={<FormattedMessage id="endpointsConnectorsAdmin.fields.connector_schedule_time"/>}
              className={("connector_schedule_time" in errors) ? "has_error" : null}
            />
          </div>
        </React.Fragment>
      )}
      {(JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.connector_schedule") == Constants.selectKeys.endpoint.connector_schedule.recurrent) && (
        <React.Fragment>
          <TextBox 
            styleType={Constants.interface.inputs.styleType.OUTLINED}
            type={Constants.interface.inputs.type.TEXT}
            id="connector_schedule_recurrent_formula"
            data-path="endpoint_connector.connector_schedule_recurrent_formula"
            value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.connector_schedule_recurrent_formula")}
            onChange={handleOnChangeForm}
            labelLocale={<FormattedMessage id="endpointsConnectorsAdmin.fields.connector_schedule_recurrent_formula"/>}
            className={("connector_schedule_recurrent_formula" in errors) ? "has_error" : null}
          />     
          <label className="form_info">
            <FormattedMessage 
              id={"endpointsConnectorsAdmin.scheduleRecurrentFormulaHelp"}
            />
          </label>
        </React.Fragment>
      )}
      {(JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.connector_schedule")) && (
        <CheckBox 
          id="connector_schedule_stop_if_valid_execution"
          className="connector_schedule_stop_if_valid_execution"
          data-path="endpoint_connector.connector_schedule_stop_if_valid_execution"
          value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.connector_schedule_stop_if_valid_execution")}
          onChange={handleOnChangeForm}
          labelLocale={<FormattedMessage id="endpointsConnectorsAdmin.fields.connector_schedule_stop_if_valid_execution"/>}
        />
      )}
      <FormSection labelLocale={intl.formatMessage({id: "endpointsConnectorsAdmin.formSections.connectorTypeConfig"})}/>
      <Select 
        id="endpoint_connector_type"
        data-path="endpoint_connector.endpoint_connector_type"
        value={endpointConnectorType}
        onChange={handleOnChangeForm}
        labelLocale={<FormattedMessage id="endpointsConnectorsAdmin.fields.endpoint_connector_type"/>}        
        options={InterfaceTooling.getSelectArray("selectKeys.endpoint.endpoint_connector_type","endpointsConnectorsAdmin.fields.selectValues.endpoint_connector_type", true)}
        className={("endpoint_connector_type" in errors) ? "has_error" : null}
      />
      {(endpointConnectorType == Constants.selectKeys.endpoint.endpoint_connector_type.calculation_unit_group_or_model_associations_endpoint_type) && (
        <React.Fragment>
          <Select 
            id="connector_calcualtion_unit_group_model_association_type"
            data-path="endpoint_connector.connector_calcualtion_unit_group_model_association_type"
            value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.connector_calcualtion_unit_group_model_association_type")}
            onChange={handleOnChangeForm}
            labelLocale={<FormattedMessage id="endpointsConnectorsAdmin.fields.connector_calcualtion_unit_group_model_association_type"/>}        
            options={InterfaceTooling.getSelectArray("selectKeys.endpoint.connector_calcualtion_unit_group_model_association_type","endpointsConnectorsAdmin.fields.selectValues.connector_calcualtion_unit_group_model_association_type", true)}
            className={("connector_calcualtion_unit_group_model_association_type" in errors) ? "has_error" : null}
          />          
          {(JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.connector_calcualtion_unit_group_model_association_type") == Constants.selectKeys.endpoint.connector_calcualtion_unit_group_model_association_type.model_calculation_unit) && (
            <Select 
              id="connector_cu_group_model_association_code_selector"
              data-path="endpoint_connector.connector_cu_group_model_association_code_selector"
              value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.connector_cu_group_model_association_code_selector")}
              onChange={handleOnChangeForm}
              labelLocale={<FormattedMessage id="endpointsConnectorsAdmin.fields.connector_cu_group_model_association_code_selector"/>}        
              options={InterfaceTooling.getSelectArray("selectKeys.endpoint.connector_cu_group_model_association_code_selector","endpointsConnectorsAdmin.fields.selectValues.connector_cu_group_model_association_code_selector", false)}
              className={("connector_cu_group_model_association_code_selector" in errors) ? "has_error" : null}
            />
          )}
          {(JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.connector_calcualtion_unit_group_model_association_type") == Constants.selectKeys.endpoint.connector_calcualtion_unit_group_model_association_type.model_calculation_unit) && (
            <ConnectorFieldsMappingList
              id="endpoint_connector_mapping"
              data-path="endpoint_connector.endpoint_connector_mapping"
              values={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.endpoint_connector_mapping") ? JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.endpoint_connector_mapping") : []}
              onChange={handleOnChangeForm}
              handleSetDefaultFields={handleSetDefaultConnectorMappingFields}
              handleLoadExternalFields={handleGetExternalFieldOptionsList}
              externalFieldsList={externalFieldOptionsList}
              defaultFieldsList={calculationUnitModelAssociationDefaultFields}
              excludeCalculationUnitMapping={excludeCalculationUnitMapping}
              blockExternalFieldsButton={!JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.id")}
              dimensionsList={dimensionsList}
              className={"endpoint_connector_mapping" + (("endpoint_connector_mapping" in errors) ? " has_error" : "")}
              isAssociationConnectorMapping={true}
              disableAddItem={true}
            />
          )}
          {(JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.connector_calcualtion_unit_group_model_association_type") == Constants.selectKeys.endpoint.connector_calcualtion_unit_group_model_association_type.group_calculation_unit) && (
            <ConnectorFieldsMappingList
              id="endpoint_connector_mapping"
              data-path="endpoint_connector.endpoint_connector_mapping"
              values={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.endpoint_connector_mapping") ? JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.endpoint_connector_mapping") : []}
              onChange={handleOnChangeForm}
              handleSetDefaultFields={handleSetDefaultConnectorMappingFields}
              handleLoadExternalFields={handleGetExternalFieldOptionsList}
              externalFieldsList={externalFieldOptionsList}
              defaultFieldsList={calculationUnitGroupAssociationDefaultFields}
              blockExternalFieldsButton={!JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.id")}
              excludeCalculationUnitMapping={excludeCalculationUnitMapping}
              dimensionsList={dimensionsList}
              className={"endpoint_connector_mapping" + (("endpoint_connector_mapping" in errors) ? " has_error" : "")}
              isAssociationConnectorMapping={true}           
            />
          )}       
          <div className="row_fields">        
            <CheckBox 
              id="connector_metric_values_iterate_calculation_units"
              className="connector_metric_values_iterate_calculation_units"
              data-path="endpoint_connector.connector_metric_values_iterate_calculation_units"
              value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.connector_metric_values_iterate_calculation_units")}
              onChange={handleOnChangeForm}
              labelLocale={LocaleTooling.getCalculationUnitContextLocale(<FormattedMessage id="endpointsConnectorsAdmin.fields.connector_metric_values_iterate_calculation_units"/>)}
            />
            {(JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.connector_metric_values_iterate_calculation_units")) && (
              <CheckBox 
                id="connector_metric_values_ignore_calculation_unit"
                className="connector_metric_values_ignore_calculation_unit"
                data-path="endpoint_connector.connector_metric_values_ignore_calculation_unit"
                value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.connector_metric_values_ignore_calculation_unit")}
                onChange={handleOnChangeForm}
                labelLocale={LocaleTooling.getCalculationUnitContextLocale(<FormattedMessage id="endpointsConnectorsAdmin.fields.connector_metric_values_ignore_calculation_unit"/>)}
              />
            )}
          </div>
          <ConnectorFieldsMappingFilterSelector
            id="endpoint_connector_mapping_filter"
            data-path="endpoint_connector.endpoint_connector_mapping_filter"
            onChange={handleOnChangeForm}
            values={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.endpoint_connector_mapping_filter") ? JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.endpoint_connector_mapping_filter") : []}
            className={"endpoint_params_editor endpoint_connector_mapping" + (("endpoint_connector_mapping_filter" in errors) ? " has_error" : "")}
          />
        </React.Fragment>
      )}
      {(endpointConnectorType == Constants.selectKeys.endpoint.endpoint_connector_type.login_endpoint_type) && (
        <Select 
          id="connector_login_token_variable_id"
          data-path="endpoint_connector.connector_login_token_variable_id"
          value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.connector_login_token_variable_id")}
          onChange={handleOnChangeForm}
          labelLocale={<FormattedMessage id="endpointsConnectorsAdmin.fields.connector_login_token_variable_id"/>}        
          options={InterfaceTooling.getSelectArrayFromArrayOfObjects(loginTypeVariablesOptionsList, "id", "name", true)}
          className={("connector_login_token_variable_id" in errors) ? "has_error" : null}
        />
      )}
      {(endpointConnectorType == Constants.selectKeys.endpoint.endpoint_connector_type.output_export_calculation_units_calculations_endpoint_type) && (
        <React.Fragment>
          <Select
            id="connector_calculations_model_code_dimension_id"
            data-path="endpoint_connector.connector_calculations_model_code_dimension_id"
            value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.connector_calculations_model_code_dimension_id")}
            onChange={handleOnChangeForm}
            labelLocale={<FormattedMessage id="endpointsConnectorsAdmin.fields.connector_calculations_model_code_dimension_id"/>}
            options={InterfaceTooling.getSelectArrayFromArrayOfObjects(dimensionsList.filter(item => !item.system_entity_class), "id", "name")}
            className={("connector_calculations_model_code_dimension_id" in errors) ? "has_error" : null}
          />
          <label className="form_info">
            <FormattedMessage 
              id={"endpointsConnectorsAdmin.fields.connector_calculations_model_code_dimension_id_help"}
            />
          </label>
        </React.Fragment>
      )}
      {(outputConnectorType) && (
        <div className="row_fields">
          {(endpointConnectorType == Constants.selectKeys.endpoint.endpoint_connector_type.output_export_calculation_units_calculations_endpoint_type) && (
            <CheckBox 
              id="connector_calculations_send_only_reprocess_delta"
              className="connector_calculations_send_only_reprocess_delta"
              data-path="endpoint_connector.connector_calculations_send_only_reprocess_delta"
              value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.connector_calculations_send_only_reprocess_delta")}
              onChange={handleOnChangeForm}
              labelLocale={<FormattedMessage id="endpointsConnectorsAdmin.fields.connector_calculations_send_only_reprocess_delta"/>}
            />
          )}
          {(endpointConnectorType == Constants.selectKeys.endpoint.endpoint_connector_type.output_export_calculation_units_reports_endpoint_type ||
            endpointConnectorType == Constants.selectKeys.endpoint.endpoint_connector_type.output_export_calculation_units_calculations_endpoint_type
          ) && (
            <CheckBox 
              id="output_connectors_has_return_data"
              className="output_connectors_has_return_data"
              data-path="endpoint_connector.output_connectors_has_return_data"
              value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.output_connectors_has_return_data")}
              onChange={handleOnChangeForm}
              labelLocale={<FormattedMessage id="endpointsConnectorsAdmin.fields.output_connectors_has_return_data"/>}
            />
          )}
        </div>
      )}
      {(endpointConnectorType == Constants.selectKeys.endpoint.endpoint_connector_type.calculation_units_endpoint_type) && (
        <React.Fragment>
          <CheckBox
            id="exclude_calculation_units_unrollment"
            data-path="endpoint_connector.exclude_calculation_units_unrollment"
            value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.exclude_calculation_units_unrollment")}
            onChange={handleOnChangeForm}
            labelLocale={LocaleTooling.getCalculationUnitContextLocale(<FormattedMessage id="endpointsConnectorsAdmin.fields.exclude_calculation_units_unrollment"/>)}
          />
          <ConnectorFieldsMappingList
            id="endpoint_connector_mapping"
            data-path="endpoint_connector.endpoint_connector_mapping"
            values={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.endpoint_connector_mapping") ? JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.endpoint_connector_mapping") : []}
            onChange={handleOnChangeForm}
            handleSetDefaultFields={handleSetDefaultConnectorMappingFields}
            handleLoadExternalFields={handleGetExternalFieldOptionsList}
            externalFieldsList={externalFieldOptionsList}
            defaultFieldsList={calculationUnitTypeFieldsOptionsList}
            blockExternalFieldsButton={!JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.id")}
            dimensionsList={dimensionsList}
            className={"endpoint_connector_mapping" + (("endpoint_connector_mapping" in errors) ? " has_error" : "")}
          />
        </React.Fragment>
      )}
      {(endpointConnectorType == Constants.selectKeys.endpoint.endpoint_connector_type.metric_values_endpoint_type) && (
        <CheckBox 
          id="connector_metric_values_delete_metric_values"
          className="connector_metric_values_delete_metric_values"
          data-path="endpoint_connector.connector_metric_values_delete_metric_values"
          value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.connector_metric_values_delete_metric_values")}
          onChange={handleOnChangeForm}
          labelLocale={LocaleTooling.getCalculationUnitContextLocale(<FormattedMessage id="endpointsConnectorsAdmin.fields.connector_metric_values_delete_metric_values"/>)}
        />
      )}
      {(endpointConnectorType == Constants.selectKeys.endpoint.endpoint_connector_type.metric_values_endpoint_type ||
        outputsMappingEnabled
      ) && (
        <Select 
          id="connector_metric_values_metric_group_id"
          data-path="endpoint_connector.connector_metric_values_metric_group_id"
          value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.connector_metric_values_metric_group_id")}
          onChange={handleOnChangeForm}
          labelLocale={<FormattedMessage id="endpointsConnectorsAdmin.fields.connector_metric_values_metric_group_id"/>}        
          options={InterfaceTooling.getSelectArrayFromArrayOfObjects(metricValueTypeMetricGroupOptionsList, "id", "name", true)}
          className={("connector_metric_values_metric_group_id" in errors) ? "has_error" : null}
        />
      )}
      {(endpointConnectorType == Constants.selectKeys.endpoint.endpoint_connector_type.metric_values_endpoint_type &&
        metricGroupSelectedAndValid
      ) && (
        <ConnectorFieldsMappingList
          id="endpoint_connector_mapping"
          data-path="endpoint_connector.endpoint_connector_mapping"
          values={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.endpoint_connector_mapping") ? JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.endpoint_connector_mapping") : []}
          onChange={handleOnChangeForm}   
          handleSetDefaultFields={handleSetDefaultConnectorMappingFields}
          handleLoadExternalFields={handleGetExternalFieldOptionsList}         
          externalFieldsList={externalFieldOptionsList}
          defaultFieldsList={metricValueTypeFieldsOptionsHeaders}
          blockExternalFieldsButton={!JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.id") || JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.connector_metric_values_iterate_calculation_units")}
          excludeCalculationUnitMapping={excludeCalculationUnitMapping}
          excludePeriodMapping={excludePeriodMapping}
          dimensionsList={dimensionsList}
          metricGroupUsePivotColumn={metricGroupUsePivotColumn}
          className={"endpoint_connector_mapping" + (("endpoint_connector_mapping" in errors) ? " has_error" : "")}
        />
      )}
      {(outputsMappingEnabled && metricGroupSelectedAndValid) && (
        <React.Fragment>
          <ConnectorFieldsMappingList
            id="endpoint_connector_mapping"
            data-path="endpoint_connector.endpoint_connector_mapping"
            values={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.endpoint_connector_mapping") ? JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.endpoint_connector_mapping") : []}
            onChange={handleOnChangeForm}   
            handleSetDefaultFields={handleSetDefaultConnectorMappingFields}
            handleLoadExternalFields={handleGetExternalFieldOptionsList}
            externalFieldsList={null}
            defaultFieldsList={metricValueTypeFieldsOptionsHeaders}
            blockExternalFieldsButton={true}
            hideExternalFieldsButton={true}
            excludeCalculationUnitMapping={excludeCalculationUnitMapping}
            excludePeriodMapping={excludePeriodMapping}
            dimensionsList={dimensionsList}
            className={"endpoint_connector_mapping" + (("endpoint_connector_mapping" in errors) ? " has_error" : "")}
          />
        </React.Fragment>
      )}
      {(showMapping && (metricGroupSelectedAndValid || endpointConnectorType == Constants.selectKeys.endpoint.endpoint_connector_type.calculation_units_endpoint_type)) && (
        <React.Fragment>
          {(!JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.id") && !outputConnectorType) && (
            <label className="form_info">
              <FormattedMessage 
                id={"endpointsConnectorsAdmin.preCreateLoadExternalDataDisclaimerInfo"}
              />
            </label>
          )}
          {(JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.id") && !outputConnectorType) && (
            <label className="form_info">
              <FormattedMessage 
                id={"endpointsConnectorsAdmin.loadExternalDataDisclaimerInfo"}
              />
            </label>
          )}
          {(endpointConnectorType == Constants.selectKeys.endpoint.endpoint_connector_type.calculation_units_endpoint_type) && (
            <div className="row_fields ignore_invalid_groups_row">
              <CheckBox 
                id="connector_calculation_units_ignore_invalid_groups"
                className="connector_calculation_units_ignore_invalid_groups"
                data-path="endpoint_connector.connector_calculation_units_ignore_invalid_groups"
                value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.connector_calculation_units_ignore_invalid_groups")}
                onChange={handleOnChangeForm}
                labelLocale={<FormattedMessage id="endpointsConnectorsAdmin.fields.connector_calculation_units_ignore_invalid_groups"/>}
              />
              <HoverTooltip 
                toolTip={intl.formatMessage({id: "endpointsConnectorsAdmin.fieldsTooltips.connector_calculation_units_ignore_invalid_groups"})}
                toolTipType={Constants.interface.toolTip.formItemHelp}
                enterDelay={300} 
                placement="left"
                leaveDelay={100}
              >
                <i 
                  className="form_tooltip_icon fas fa-exclamation-circle"
                />
              </HoverTooltip>
            </div>         
          )}        
          <CheckBox 
            id="input_connectors_is_csv_numbers_format"
            className="input_connectors_is_csv_numbers_format"
            data-path="endpoint_connector.input_connectors_is_csv_numbers_format"
            value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.input_connectors_is_csv_numbers_format")}
            onChange={handleOnChangeForm}
            labelLocale={<FormattedMessage id="endpointsConnectorsAdmin.fields.input_connectors_is_csv_numbers_format"/>}
          />
          <ConnectorFieldsMappingFilterSelector
            id="endpoint_connector_mapping_filter"
            data-path="endpoint_connector.endpoint_connector_mapping_filter"
            onChange={handleOnChangeForm}
            values={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.endpoint_connector_mapping_filter") ? JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.endpoint_connector_mapping_filter") : []}
            className={"endpoint_params_editor endpoint_connector_mapping" + (("endpoint_connector_mapping_filter" in errors) ? " has_error" : "")}
          />
        </React.Fragment>  
      )}
      {(endpointConnectorType == Constants.selectKeys.endpoint.endpoint_connector_type.calculation_units_endpoint_type) && (
        <Select 
          id="connector_calculation_units_user_id"
          data-path="endpoint_connector.connector_calculation_units_user_id"
          value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.connector_calculation_units_user_id")}
          onChange={handleOnChangeForm}
          labelLocale={<FormattedMessage id="endpointsConnectorsAdmin.fields.connector_calculation_units_user_id"/>}        
          options={InterfaceTooling.getSelectArrayFromArrayOfObjects(usersList, "id", "email", true)}
          className={("connector_calculation_units_user_id" in errors) ? "has_error" : null}
        />
      )}
      {(endpointConnectorType == Constants.selectKeys.endpoint.endpoint_connector_type.metric_values_endpoint_type ||
        outputsMappingEnabled
      ) && (
        <React.Fragment>
          <div className="row_fields">
            {(endpointConnectorType == Constants.selectKeys.endpoint.endpoint_connector_type.metric_values_endpoint_type) && (
              <CheckBox 
                id="connector_metric_values_iterate_calculation_units"
                className="connector_metric_values_iterate_calculation_units"
                data-path="endpoint_connector.connector_metric_values_iterate_calculation_units"
                value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.connector_metric_values_iterate_calculation_units")}
                onChange={handleOnChangeForm}
                labelLocale={LocaleTooling.getCalculationUnitContextLocale(<FormattedMessage id="endpointsConnectorsAdmin.fields.connector_metric_values_iterate_calculation_units"/>)}
              />
            )}
            <CheckBox 
              id="connector_metric_values_ignore_period"
              className="connector_metric_values_ignore_period"
              data-path="endpoint_connector.connector_metric_values_ignore_period"
              value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.connector_metric_values_ignore_period")}
              onChange={handleOnChangeForm}
              labelLocale={<FormattedMessage id="endpointsConnectorsAdmin.fields.connector_metric_values_ignore_period"/>}
            />
          </div>          
          {(JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.connector_metric_values_iterate_calculation_units") ||
            outputsMappingEnabled
          ) && (
            <div className="row_fields">
              <CheckBox 
                id="connector_metric_values_ignore_calculation_unit"
                className="connector_metric_values_ignore_calculation_unit"
                data-path="endpoint_connector.connector_metric_values_ignore_calculation_unit"
                value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.connector_metric_values_ignore_calculation_unit")}
                onChange={handleOnChangeForm}
                labelLocale={LocaleTooling.getCalculationUnitContextLocale(<FormattedMessage id="endpointsConnectorsAdmin.fields.connector_metric_values_ignore_calculation_unit"/>)}
              />
            </div>
          )}
        </React.Fragment>
      )}
      {(endpointConnectorType == Constants.selectKeys.endpoint.endpoint_connector_type.calculation_units_endpoint_type) && (
        <CheckBox 
          id="connector_calculation_units_ignore_duplicates"
          className="connector_calculation_units_ignore_duplicates"
          data-path="endpoint_connector.connector_calculation_units_ignore_duplicates"
          value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.connector_calculation_units_ignore_duplicates")}
          onChange={handleOnChangeForm}
          labelLocale={LocaleTooling.getCalculationUnitContextLocale(<FormattedMessage id="endpointsConnectorsAdmin.fields.connector_calculation_units_ignore_duplicates"/>)}
        />
      )}        
      {JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.id") && (
        <CheckBox 
          id="active"
          data-path="endpoint_connector.active"
          value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"endpoint_connector.active")}
          onChange={handleOnChangeForm}
          labelLocale={<FormattedMessage id="common.entity.fields.active"/>}
        />
      )}
    </GlassPopup>
  );
};

export default FormPopup;



// WEBPACK FOOTER //
// ./source/client/components/endpointsconnectorsAdmin/formPopup.jsx